import { j as o } from "./jsx-runtime-Bdg6XQ1m.js";
import { c as N, L as Y, e as $, i as O } from "./chunk-SYFQ2XB5-BF5IDYrB.js";
import { UnlinkIcon as w } from "lucide-react";
import { C as M } from "./CategoryHeading-MYL1u_6K.js";
import { Callout as b } from "./ui/Callout.js";
import { M as F, P as L, H as I } from "./Markdown-DFN6p0J-.js";
import { Z as C } from "./invariant-Caa8-XvF.js";
import v, { useContext as k } from "react";
import { u as D } from "./useExposedProps-CetwhZpP.js";
const g = ({
  children: r,
  className: s
}) => {
  if (process.env.NODE_ENV === "development")
    return /* @__PURE__ */ o.jsx(b, { type: "caution", title: "Developer hint", className: s, children: /* @__PURE__ */ o.jsxs("div", { className: "flex flex-col gap-2", children: [
      typeof r == "string" ? /* @__PURE__ */ o.jsx(F, { content: r }) : /* @__PURE__ */ o.jsx("div", { children: r }),
      /* @__PURE__ */ o.jsx("small", { className: "italic", children: "Note: This hint is only shown in development mode." })
    ] }) });
}, U = () => {
  const r = N();
  return /* @__PURE__ */ o.jsxs("div", { className: L + " h-full pt-[--padding-content-top]", children: [
    /* @__PURE__ */ o.jsx(M, { children: "404" }),
    /* @__PURE__ */ o.jsxs(I, { level: 1, className: "flex gap-3.5 items-center", children: [
      "Page not found",
      /* @__PURE__ */ o.jsx(w, { size: 24 })
    ] }),
    /* @__PURE__ */ o.jsxs(g, { children: [
      "Start by adding a file at",
      " ",
      /* @__PURE__ */ o.jsxs("code", { children: [
        "{PROJECT_ROOT}",
        "/",
        r["*"],
        ".mdx"
      ] }),
      " ",
      "and add some content to make this error go away."
    ] }),
    /* @__PURE__ */ o.jsx("p", { children: "It seems that the page you are looking for does not exist or may have been moved. Please check the URL for any typos or use the navigation menu to find the correct page." }),
    /* @__PURE__ */ o.jsx(Y, { to: "/", children: "Go back home" })
  ] });
};
function z({ error: r }) {
  const s = r instanceof Error ? r.message : "Something went wrong", a = r instanceof C ? r.developerHint : void 0, c = r instanceof C ? r.title : "Something went wrong", u = r instanceof Error ? r.stack : void 0, l = r instanceof Error ? r.cause : void 0;
  return /* @__PURE__ */ o.jsx("div", { className: "flex h-screen max-h-[calc(100vh-var(--header-height))] min-h-full items-center justify-center bg-primary-background px-4 py-16 lg:px-8", children: /* @__PURE__ */ o.jsxs("div", { className: "mx-auto max-w-[85%] sm:max-w-[50%]", children: [
    /* @__PURE__ */ o.jsx("h1", { className: "text-4xl font-bold tracking-tight text-h1-text sm:text-5xl", children: c }),
    /* @__PURE__ */ o.jsx("p", { className: "mt-5 text-h1-text", children: s }),
    a && /* @__PURE__ */ o.jsx(g, { className: "mb-4", children: a }),
    l instanceof Error ? /* @__PURE__ */ o.jsx("pre", { className: "mt-5 max-h-[400px] w-full overflow-scroll rounded-md border border-input-border bg-input-background p-3 text-property-name-text text-red-700", children: l.stack }) : u ? /* @__PURE__ */ o.jsx("pre", { className: "mt-5 max-h-[400px] w-full overflow-scroll rounded-md border border-input-border bg-input-background p-3 text-property-name-text text-red-700", children: u }) : null
  ] }) });
}
function re() {
  const r = $();
  return O(r) && r.status === 404 ? /* @__PURE__ */ o.jsx(U, {}) : /* @__PURE__ */ o.jsx(z, { error: r });
}
var R = { exports: {} }, t = {};
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var P;
function q() {
  if (P) return t;
  P = 1;
  var r = Symbol.for("react.transitional.element"), s = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), c = Symbol.for("react.strict_mode"), u = Symbol.for("react.profiler"), l = Symbol.for("react.consumer"), f = Symbol.for("react.context"), m = Symbol.for("react.forward_ref"), E = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), _ = Symbol.for("react.lazy"), x = Symbol.for("react.offscreen"), S = Symbol.for("react.client.reference");
  function i(e) {
    if (typeof e == "object" && e !== null) {
      var T = e.$$typeof;
      switch (T) {
        case r:
          switch (e = e.type, e) {
            case a:
            case u:
            case c:
            case E:
            case d:
              return e;
            default:
              switch (e = e && e.$$typeof, e) {
                case f:
                case m:
                case _:
                case p:
                  return e;
                case l:
                  return e;
                default:
                  return T;
              }
          }
        case s:
          return T;
      }
    }
  }
  return t.ContextConsumer = l, t.ContextProvider = f, t.Element = r, t.ForwardRef = m, t.Fragment = a, t.Lazy = _, t.Memo = p, t.Portal = s, t.Profiler = u, t.StrictMode = c, t.Suspense = E, t.SuspenseList = d, t.isContextConsumer = function(e) {
    return i(e) === l;
  }, t.isContextProvider = function(e) {
    return i(e) === f;
  }, t.isElement = function(e) {
    return typeof e == "object" && e !== null && e.$$typeof === r;
  }, t.isForwardRef = function(e) {
    return i(e) === m;
  }, t.isFragment = function(e) {
    return i(e) === a;
  }, t.isLazy = function(e) {
    return i(e) === _;
  }, t.isMemo = function(e) {
    return i(e) === p;
  }, t.isPortal = function(e) {
    return i(e) === s;
  }, t.isProfiler = function(e) {
    return i(e) === u;
  }, t.isStrictMode = function(e) {
    return i(e) === c;
  }, t.isSuspense = function(e) {
    return i(e) === E;
  }, t.isSuspenseList = function(e) {
    return i(e) === d;
  }, t.isValidElementType = function(e) {
    return typeof e == "string" || typeof e == "function" || e === a || e === u || e === c || e === E || e === d || e === x || typeof e == "object" && e !== null && (e.$$typeof === _ || e.$$typeof === p || e.$$typeof === f || e.$$typeof === l || e.$$typeof === m || e.$$typeof === S || e.getModuleId !== void 0);
  }, t.typeOf = i, t;
}
var n = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var h;
function V() {
  return h || (h = 1, process.env.NODE_ENV !== "production" && function() {
    function r(e) {
      if (typeof e == "object" && e !== null) {
        var T = e.$$typeof;
        switch (T) {
          case s:
            switch (e = e.type, e) {
              case c:
              case l:
              case u:
              case d:
              case p:
                return e;
              default:
                switch (e = e && e.$$typeof, e) {
                  case m:
                  case E:
                  case x:
                  case _:
                    return e;
                  case f:
                    return e;
                  default:
                    return T;
                }
            }
          case a:
            return T;
        }
      }
    }
    var s = Symbol.for("react.transitional.element"), a = Symbol.for("react.portal"), c = Symbol.for("react.fragment"), u = Symbol.for("react.strict_mode"), l = Symbol.for("react.profiler"), f = Symbol.for("react.consumer"), m = Symbol.for("react.context"), E = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), _ = Symbol.for("react.memo"), x = Symbol.for("react.lazy"), S = Symbol.for("react.offscreen"), i = Symbol.for("react.client.reference");
    n.ContextConsumer = f, n.ContextProvider = m, n.Element = s, n.ForwardRef = E, n.Fragment = c, n.Lazy = x, n.Memo = _, n.Portal = a, n.Profiler = l, n.StrictMode = u, n.Suspense = d, n.SuspenseList = p, n.isContextConsumer = function(e) {
      return r(e) === f;
    }, n.isContextProvider = function(e) {
      return r(e) === m;
    }, n.isElement = function(e) {
      return typeof e == "object" && e !== null && e.$$typeof === s;
    }, n.isForwardRef = function(e) {
      return r(e) === E;
    }, n.isFragment = function(e) {
      return r(e) === c;
    }, n.isLazy = function(e) {
      return r(e) === x;
    }, n.isMemo = function(e) {
      return r(e) === _;
    }, n.isPortal = function(e) {
      return r(e) === a;
    }, n.isProfiler = function(e) {
      return r(e) === l;
    }, n.isStrictMode = function(e) {
      return r(e) === u;
    }, n.isSuspense = function(e) {
      return r(e) === d;
    }, n.isSuspenseList = function(e) {
      return r(e) === p;
    }, n.isValidElementType = function(e) {
      return typeof e == "string" || typeof e == "function" || e === c || e === l || e === u || e === d || e === p || e === S || typeof e == "object" && e !== null && (e.$$typeof === x || e.$$typeof === _ || e.$$typeof === m || e.$$typeof === f || e.$$typeof === E || e.$$typeof === i || e.getModuleId !== void 0);
    }, n.typeOf = r;
  }()), n;
}
var y;
function H() {
  return y || (y = 1, process.env.NODE_ENV === "production" ? R.exports = /* @__PURE__ */ q() : R.exports = /* @__PURE__ */ V()), R.exports;
}
var j = /* @__PURE__ */ H();
const A = v.createContext({}), te = ({
  slotlets: r,
  children: s
}) => /* @__PURE__ */ o.jsx(A.Provider, { value: r, children: s }), ne = ({ name: r }) => {
  const s = k(A), a = s == null ? void 0 : s[r], c = D();
  return j.isValidElementType(a) ? v.createElement(a, c) : a;
};
export {
  g as D,
  z as E,
  re as R,
  ne as S,
  te as a
};
//# sourceMappingURL=SlotletProvider-_3zzX_g_.js.map
